@if (selectedPeriode !== 0 && hasWerknemerGegevens && (werknemerEntity$ | async) && (loonstaatEntity$ | async)) {
  <div>

    @if (isVerzonden) {
      <snelstart-ui-alert type="warning">
        De aangifte loonheffingen over deze periode is al verzonden. Dat betekent dat je deze periode niet meer
        kunt muteren in SnelStart Salaris. Verwerk mutaties in de eerstvolgende nog niet verloonde periode of neem
        contact op met onze klantenservice.
      </snelstart-ui-alert>
    }

    <!-- VASTE VERGOEDINGEN -->
    <form [formGroup]="lijstFg">
      <div formArrayName="vasteVergoedingen">
        @for (item of getVasteVergoedingen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            @if (showInPeriode(item.getRawValue())) {
            <div class="row">
              <div class="col col-1">
                {{ formatComponentLabel(
                item.get('component')?.getRawValue(),
                item.get('displayValue')?.getRawValue()
              ) }}
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [calculate]="prorata(i)"
                  [disabledControl]="true"
                  [formControl]="item.controls.proRataVergoeding"
                  [showAllDecimals]="true"
                  align="right"
                  class="me-1 custom-input-150"
                  prefix="€">
                </snelstart-ui-number-form-control>
              </div>
              <div class="col-3"></div>
            </div>
            }
          </div>
        }
      </div>
    </form>

    <!-- ACTIE + TOTAAL VAST -->
    <form [formGroup]="lijstFg">
      <div class="pb-3">
        <div class="row">
          <div class="col col-1 pt-1">
            <b>Totaal vaste componenten</b>
          </div>
          <div class="col-2">
            <snelstart-ui-button (click)="openVariabeleVergoedingTab()"
                                 [disabled]="isVerzonden"
                                 icon="plus"
                                 class="custom-input-150"
                                 type="secondary">
              Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control
              [calculate]="getTotaalVast()"
              [disabledControl]="true"
              [showAllDecimals]="true"
              align="right"
              class="me-1 custom-input-150"
              formControlName="totaalVast"
              prefix="€">
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </div>
    </form>

    <!-- VARIABELE VERGOEDINGEN -->
    <form [formGroup]="lijstFg">
      <div formArrayName="variabeleVergoedingen">
        @for (item of getVariabeleVergoedingen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            @if (showInPeriode(item.getRawValue())) {
            <div class="row">
              <div class="col col-1">
                {{ formatComponentLabel(
                item.get('component')?.getRawValue(),
                item.get('displayValue')?.getRawValue()
              ) }}
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [disabledControl]="true"
                  [formControl]="item.controls.bedrag"
                  [prefix]="'€'"
                  [showAllDecimals]="true"
                  align="right"
                  class="me-1 custom-input-150"
                  >
                </snelstart-ui-number-form-control>
              </div>
              <div class="col-3">
              </div>
            </div>
            }
          </div>
        }
      </div>
    </form>

    <!-- ACTIE + TOTAAL VARIABEL -->
    <form [formGroup]="lijstFg">
      <div class="pb-3">
        <div class="row">
          <div class="col col-1 pt-1">
            <b>Totaal variabele componenten</b>
          </div>
          <div class="col-2">
            @if (!isVerzonden) {
              <snelstart-venture-fiscaal-variabelevergoeding>
              </snelstart-venture-fiscaal-variabelevergoeding>
            }
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control
              [calculate]="getTotaalVariabel()"
              [disabledControl]="true"
              [showAllDecimals]="true"
              align="right"
              class="me-1 custom-input-150"
              formControlName="totaalVariabel"
              prefix="€">
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </div>
    </form>

    <!-- INHOUDINGEN (berekendeVergoedingen) -->
    <form [formGroup]="lijstFg">
      <div formArrayName="berekendeVergoedingen">
        @for (item of vergoedingen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            @if (inhoudingComponent(item.get('component')?.value)) {
            <div class="row">
              <div class="col col-1">
                {{ formatComponentLabel(
                item.get('component')?.getRawValue(),
                item.get('displayValue')?.getRawValue()
              ) }}
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [disabledControl]="true"
                  [formControl]="item.controls.berekendeAanwas"
                  [showAllDecimals]="true"
                  align="right"
                  class="me-1 custom-input-150"
                  prefix="€">
                </snelstart-ui-number-form-control>
              </div>
              <div class="col-3"></div>
            </div>
            }
          </div>
        }
      </div>
    </form>

    <!-- TOTAAL INHOUDINGEN -->
    <form [formGroup]="lijstFg">
      <div class="pb-3">
        <div class="row">
          <div class="col col-1">
            <b>Totaal inhoudingen</b>
          </div>
          <div class="col-2"></div>
          <div class="col-3">
            <snelstart-ui-number-form-control
              [calculate]="getTotaalInhoudingen()"
              [disabledControl]="true"
              [showAllDecimals]="true"
              align="right"
              class="me-1 custom-input-150"
              formControlName="totaalInhouding"
              prefix="€ -">
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </div>
    </form>

    <!-- NETTOLOON -->
    <form [formGroup]="lijstFg">
      <div formArrayName="berekendeVergoedingen">
        @for (item of vergoedingen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            @if (item.get('component')?.value === 'NETTOLOON') {
            <div class="row">
              <div class="col col-1">
                {{ formatComponentLabel(
                item.get('component')?.getRawValue(),
                item.get('displayValue')?.getRawValue()
              ) }}
              </div>
              <div class="col-2"></div>
              <div class="col-3">
                <snelstart-ui-number-form-control
                  [disabledControl]="true"
                  [formControl]="item.controls.bedrag"
                  [showAllDecimals]="true"
                  align="right"
                  class="me-1 custom-input-150"
                  prefix="€">
                </snelstart-ui-number-form-control>
              </div>
            </div>
            }
          </div>
        }
      </div>
    </form>
  </div>
}

